import { useState } from "react";
import { Link } from "react-router-dom";

const INK = "var(--pr-ink)";
const GOLD = "var(--pr-gold)";

// Persistent (but calm) race-status banner for Free Sprint racers.
const API = process.env.REACT_APP_BACKEND_URL;

const PromoApply = ({ suffix }) => {
  const [open, setOpen] = useState(false);
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(null);
  const [err, setErr] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    if (!code.trim() || busy) return;
    setBusy(true); setErr("");
    try {
      const res = await fetch(`${API}/api/caddy/promo`, { method: "POST", credentials: "include",
        headers: { "Content-Type": "application/json" }, body: JSON.stringify({ code: code.trim() }) });
      const d = await res.json();
      if (!res.ok) { setErr(d.detail || "Couldn't apply that code."); return; }
      setDone(d);
    } catch { setErr("Network hiccup, try again."); } finally { setBusy(false); }
  };
  if (done) {
    return (
      <p className="text-xs mt-2.5" style={{ color: GOLD }} data-testid={`sprint-promo-applied${suffix}`}>
        ✓ {done.code} applied, {done.summary}. Nothing changes during your Sprint.
      </p>
    );
  }
  if (!open) {
    return (
      <button type="button" onClick={() => setOpen(true)} className="block text-xs underline mt-2.5" style={{ color: "rgba(255,255,255,0.75)" }} data-testid={`sprint-promo-toggle${suffix}`}>
        Have a beta code? Apply it before your Sprint converts →
      </button>
    );
  }
  return (
    <form onSubmit={submit} className="mt-2.5 flex flex-wrap items-center gap-2" data-testid={`sprint-promo-form${suffix}`}>
      <input value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} placeholder="RELAYBETA…" maxLength={40}
        className="rounded-full px-3 py-1.5 text-xs font-mono tracking-wider w-40" style={{ background: "rgba(255,255,255,0.12)", color: "#fff", border: "1px solid rgba(255,255,255,0.25)" }}
        data-testid={`sprint-promo-input${suffix}`} />
      <button type="submit" disabled={busy || !code.trim()} className="px-3 py-1.5 rounded-full text-xs font-bold disabled:opacity-40" style={{ background: GOLD, color: "var(--pr-on-gold)" }} data-testid={`sprint-promo-submit${suffix}`}>
        {busy ? "Applying…" : "Apply"}
      </button>
      {err && <span className="text-xs w-full" style={{ color: "#FFB4A8" }} data-testid={`sprint-promo-error${suffix}`}>{err}</span>}
    </form>
  );
};

export const SprintBanner = ({ sprint, suffix = "" }) => {
  if (!sprint) return null;
  const days = sprint.days_left;
  const endsLine =
    days == null
      ? "Your Free Sprint is live."
      : days <= 0
        ? "Your Free Sprint ends today."
        : `Your Free Sprint ends in ${days} day${days === 1 ? "" : "s"}.`;
  return (
    <div
      className="rounded-2xl p-5 lg:p-6 pr-card-dark"
      style={{ background: "var(--pr-ink-surface)" }}
      data-testid={`sprint-banner${suffix}`}
    >
      <div className="flex items-start gap-3">
        <span className="text-2xl">🏁</span>
        <div className="flex-1 min-w-0">
          <p className="text-[10px] font-bold uppercase tracking-[0.2em]" style={{ color: GOLD }} data-testid={`sprint-banner-relay${suffix}`}>
            Free Sprint · Relay {sprint.relay} of {sprint.of}
          </p>
          <p className="text-sm font-bold mt-0.5" style={{ color: "#FFFFFF" }}>{endsLine}</p>
          <p className="text-xs leading-relaxed mt-1" style={{ color: "rgba(255,255,255,0.8)" }}>
            When your Sprint wraps, your full 52-week Payday Relay race starts fresh with a new sheet, you'll keep your Sprint settings or adjust your first quarter before you begin.
          </p>
          <Link
            to="/start/season-pass"
            className="inline-block mt-2.5 px-4 py-2 rounded-full font-bold text-xs transition-transform hover:scale-105"
            style={{ background: "var(--pr-gold)", color: "var(--pr-on-gold)" }}
            data-testid={`sprint-banner-cta${suffix}`}
          >
            Start My Payday Relay Race →
          </Link>
          <PromoApply suffix={suffix} />
        </div>
      </div>
    </div>
  );
};
